/**
 * @file AdUnitSearchMiddleSlot.tsx
 *
 * @fileoverview Renders row ad unit for the top of the job search page.
 */

interface AdUnitSearchMiddleSlotProps {}

export default function AdUnitSearchMiddleSlot({}: AdUnitSearchMiddleSlotProps) {
  return <></>;
}

export { AdUnitSearchMiddleSlot };
